type StatusPillProps = {
  children: string;
  tone?: "neutral" | "green" | "orange" | "red" | "blue";
};

const inferTone = (value: string): StatusPillProps["tone"] => {
  const text = value.toLowerCase();

  if (text.includes("lỗi") || text.includes("thấp") || text.includes("lệch")) {
    return "red";
  }

  if (text.includes("chờ") || text.includes("đang") || text.includes("cần")) {
    return "orange";
  }

  if (text.includes("khả dụng") || text.includes("tốt") || text.includes("hoàn")) {
    return "green";
  }

  if (text.includes("sync") || text.includes("mới")) {
    return "blue";
  }

  return "neutral";
};

export function StatusPill({ children, tone = inferTone(children) }: StatusPillProps) {
  return <span className={`pill pill-${tone}`}>{children}</span>;
}
